import React, { useState, useEffect } from 'react'
import Game from './Game'
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import Modal from '@mui/material/Modal'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import styled from 'styled-components'

const StyledApp = styled.div`
  text-align: center;
`

const StyleAppBar = styled(AppBar)`
  background-color: #333;
`

const StyledModal = styled(Modal)`

`

const StyledBox = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60%;
  height: 60vh;
  background-color: white;
  border: 2px solid #000;
  box-shadow: 4px 4px 0px 0px #000;
  padding: 1rem;
  word-wrap: break-word;

  @media (max-width: 768px) {
    height: 80vh;
    width: 80%;
  }
`

function App (): JSX.Element {
  const [open, setOpen] = useState(false)

  const handleClose = (): void => { setOpen(false) }
  const handleOpen = (): void => { setOpen(true) }

  useEffect(() => {
    handleOpen()
  }, [])

  return (
    <StyledApp>
      <StyleAppBar position="static">
        <Toolbar>
          <Typography fontFamily="player2" variant="h6" component="div" sx={{ flexGrow: 1 }}>
            PokeConnections
          </Typography>
        </Toolbar>
      </StyleAppBar>
      <Game />
      <StyledModal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <StyledBox>
          <Typography fontFamily='player2' id="modal-modal-title" variant="h6" component="h2">
            Welcome to PokeConnections!
          </Typography>
          <Typography fontFamily='player2' id="modal-modal-description" sx={{ mt: 2 }}>
            Goal:
          </Typography>
          <Typography fontFamily='player2' id="modal-modal-description" sx={{ mt: 2 }}>
            Identify the Pokemon that are connected by a common trait.
            <br/><br/>
            If you need help, click on the trait you are struggling with to reveal a hint.
          </Typography>
          <Typography fontFamily='player2' id="modal-modal-description" sx={{ mt: 2 }}>
            PS: Be Careful! You only have 6 lives.
          </Typography>
          <Typography fontFamily='player2' id="modal-modal-description" sx={{ mt: 2 }}>
            PPS: If the board does not load within 10 seconds, please refresh the page.
          </Typography>
        </StyledBox>
      </StyledModal>
    </StyledApp>
  )
}

export default App
